export default __webpack_public_path__ + "static/media/10@2x.c6bd094f.png";